import { createReducer, on } from '@ngrx/store';

import { AssociationLabel } from '@shared/models';

import { associationLabelGetSuccess } from './association-label.actions';

export interface AssociationLabelState {
  [jobId: number]: { [candidateId: number]: AssociationLabel };
}

const initialState = {};
const reducer = createReducer(
  initialState,
  on(associationLabelGetSuccess, (state, { entities }) => {
    const newState = { ...state };
    entities.forEach(
      (entity) =>
        (newState[entity.jobId] = {
          ...newState[entity.jobId],
          [entity.candidateId]: entity.label,
        }),
    );
    return newState;
  }),
);

export function associationLabelReducer(state: AssociationLabelState, action) {
  return reducer(state, action);
}
